import { FC } from 'react';
import { useGetCurrentUser } from '@/custom-hooks';
import { useNavigate } from 'react-router';

type propsType = {
};

export const UserAssignmentsHth: FC<propsType> = ({ }) => {
    const navigate = useNavigate();
    const user = useGetCurrentUser();

    return (
        <div className={'my-2'}>
            <h3>
                Territorios de Casa en Casa asignados:
            </h3>
            {!!user.hthAssignments?.length ?
                user.hthAssignments.map(a =>
                    <button key={a.id}
                        className={'btn btn-general-blue d-inline-block text-center mt-3 mx-1 px-0'}
                        style={{ fontWeight: 'bolder', width: '65px' }}
                        onClick={() => navigate(`/casa-en-casa/${a.territoryNumber}`)}
                    >
                        {a.territoryNumber}
                    </button>
                )
                :
                <h4>
                    Ninguno
                </h4>
            }
        </div>
    );
}
